import React from 'react'

export default function ModalSkelton() {
    return (
        <div className='row'>
            <div className='col-lg-7'>
                <div>
                <div className="card-skl m-3">
                    <div className="card-img-skl skeleton skl-height skl-non-modal">
                    </div>
                    
                </div>
                </div>
            </div>
            <div className='col-lg-5'>
                <div className="card-skl m-3">
                    <div className="card-img-skl skeleton skl-height">
                    </div>
                    <div className="card-body-skl">
                        <h2 className="card-title-skl skeleton">
                        </h2>
                       
                    </div>
                </div>
            </div>
        </div>
    )
}
